export * from '@primeuix/themes/material/inputchips';
export { default } from '@primeuix/themes/material/inputchips';
